import { Badge, BadgeProps, styled } from "@mui/material";

export const StyledBadge = styled(Badge)<BadgeProps & { size?: "small" | "normal" }>(({ theme, size }) => ({
  "& .MuiBadge-badge": {
    right: size === "small" ? 2 : -5,
    top: size === "small" ? 0 : 4,
    border: `2px solid ${theme.palette.common.white}`,
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    fontSize: size === "small" ? "0.625rem" : "0.75rem",
  },
}));
